module.exports = __webpack_public_path__ + "img/gb-wls.d7d7c77c.png";